import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";

class MasterHadiahFilter extends Component {
    qrOptions = [
        {
            label: "YES",
            value: true,
        },
        {
            label: "NO",
            value: false,
        },
    ];

    handleSubmit = () => {
        this.props.onSubmit();
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_kode_hadiah"
                                name="kodeHadiah"
                                label="Kode Hadiah"
                                value={this.props.selectedData.kodeHadiah}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_hadiah"
                                name="nameHadiah"
                                label="Nama Hadiah"
                                value={this.props.selectedData.nameHadiah}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_filter_kategori"
                                box="search"
                                name="categoryHadiah"
                                label="Kategori"
                                isClearable
                                options={this.props.dataKategoriDDL}
                                value={this.props.selectedData.categoryHadiah}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_filter_qrcode"
                                box="search"
                                name="qrHadiah"
                                label="QR Code"
                                isClearable
                                options={this.qrOptions}
                                value={this.props.selectedData.qrHadiah}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_filter_satuan"
                                box="search"
                                name="satuanHadiah"
                                label="Satuan"
                                isClearable
                                options={this.props.dataSatuanDDL}
                                value={this.props.selectedData.satuanHadiah}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <FlexView hAlignContent="right">
                                <SimpleButton type="button" secondary onClick={() => this.props.onClearForm()}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </FlexView>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterHadiahFilter;